// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"a64475ab","251":"3d913758","644":"9fbc4040","787":"15f1acdd","860":"9f1b0702"}[chunkId] + ".chunk.js";
};